// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { IContactTypeData, contactTypeData } from 'src/app/features/contact-type/models/contact-type/contact-type-data';

export const contactTypeDto = {
    guid: 'guid',
    nr: 'nr',
    description: 'description',
    system: 'system',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TContactTypeDto = (typeof contactTypeDto)[keyof typeof contactTypeDto];

export const contactTypeDtoConstraints = {
    description: { required: true, maxLength: 40 },
    system: { required: true },
} as const;

export type TContactTypeDtoConstraints = typeof contactTypeDtoConstraints;

export interface IContactTypeDto extends ILevelDomainDto {
    [contactTypeDto.guid]: string | null;
    [contactTypeDto.nr]: number | null;
    [contactTypeDto.description]: string | null;
    [contactTypeDto.system]: boolean | null;
    [contactTypeDto.deleted]: boolean | null;
    [contactTypeDto.inactive]: boolean | null;
}

export class ContactTypeDto
    implements IContactTypeDto
{
    [contactTypeDto.guid]: string | null = null;
    [contactTypeDto.nr]: number | null = null;
    [contactTypeDto.description]: string | null = null;
    [contactTypeDto.system]: boolean | null = null;
    [contactTypeDto.deleted]: boolean | null = null;
    [contactTypeDto.inactive]: boolean | null = null;

    private constructor(
        modelData: IContactTypeData,
    ) {
        this[contactTypeDto.guid] = modelData[contactTypeData.guid];
        this[contactTypeDto.nr] = modelData[contactTypeData.nr];
        this[contactTypeDto.description] = modelData[contactTypeData.description];
        this[contactTypeDto.system] = modelData[contactTypeData.system];
        this[contactTypeDto.deleted] = modelData[contactTypeData.deleted];
        this[contactTypeDto.inactive] = modelData[contactTypeData.inactive];
    }

    static create(modelData?: IContactTypeData | null): IContactTypeDto | null {
        return modelData ? new ContactTypeDto(modelData) : null;
    }
}
